export enum MetadataDataFormat {
  Text = 'text',
  Date = 'date',
  Number = 'number',
  YesNo = 'yesNo',
  List = 'list',
}

export interface MetadataTranslation {
  languageId: number;
  language: string;
  value: string;
}

export interface MetadataField {
  uniqueId: string;
  displayName: string;
  format: MetadataDataFormat;
  documentTypeIds: string[];
  documentTypeNames: string[];
  extractionQuestion: string;
  translations: MetadataTranslation[];
  order: number;
}

export interface MetadataUpsertModel {
  displayName: string;
  format: MetadataDataFormat;
  documentTypeIds: string[];
  documentTypeNames: string[];
  extractionQuestion: string;
  translations: MetadataTranslation[];
}